import { getCurrentInstance } from 'vue';
import { UnleashClient, plugin, useUnleashClient } from '@unleash/proxy-client-vue';
import type { Plugin } from 'vue';
import type { IConfig } from '@unleash/proxy-client-vue';

let unleashClient: UnleashClient;

type CreateUnleashOptions = IConfig & { startClient?: boolean };

export function createFeatureFlags(options: CreateUnleashOptions): Plugin {
  unleashClient = new UnleashClient(options);

  return {
    install(app) {
      app.use(plugin, { unleashClient, startClient: options.startClient ?? false });
    },
  };
}

export function useFeatureFlags(): UnleashClient {
  const client = getCurrentInstance() ? useUnleashClient() : unleashClient;

  if (!client) {
    throw new Error('`useFeatureFlags()` was called with no installed Feature Flags');
  }

  return client;
}

export * from './feature-flags';
export { useFlag, useFlagsStatus, useUnleashContext, useVariant } from '@unleash/proxy-client-vue';
